import createCache from '@emotion/cache'

export const createMinutesEmotionCache = (nonce?: string) =>
    createCache({
        key: 'minutes',
        nonce
    })
